var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShuju2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.2a.5.5 0 000 1v-1zm2.8-2.7l.478-.148a.5.5 0 00-.941-.04L5.3 4.5zM7 10l-.478.148a.5.5 0 00.95.016L7 10zm2.6-7.5l.47-.172a.5.5 0 00-.942.008L9.6 2.5zm3.9 5.7a.5.5 0 000-1v1zm-2.008-.522l-.47.172.47-.172zm-7.484.001l.463.188-.463-.188zM2.5 8.2h1.477v-1H2.5v1zm1.97-.332l1.293-3.18-.926-.376L3.545 7.49l.926.377zm.352-3.22l1.7 5.5.956-.296-1.7-5.5-.956.296zm2.65 5.516l2.6-7.5-.944-.328-2.6 7.5.944.328zM9.13 2.672l1.892 5.178.94-.343-1.892-5.179-.94.344zM11.523 8.2H13.5v-1h-1.977v1zm-.5-.35c.076.21.276.35.5.35v-1c.196 0 .371.122.439.307l-.94.343zm-7.046.35a.533.533 0 00.494-.332l-.926-.377a.467.467 0 01.432-.291v1z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13h11",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_shuju2.4e5f5ef5.svg";
export { SvgTongyongShuju2 as ReactComponent };